/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React, { Children, cloneElement, PropTypes } from 'react'
import classnames from 'classnames'
import isUndefined from 'lodash/isUndefined'
import omit from 'lodash/omit'
import omitBy from 'lodash/omitBy'

import styles from './Row.scss'

const Row = (props) => {
  const { children, className } = props
  const filteredProps = omitBy(props, isUndefined)
  const childrenProps = omit(filteredProps, ['children', 'className'])
  const cleanChildren = React.Children.toArray(children).filter(child => child !== null)

  return (
    <div className={classnames(styles.base, className)}>
      {Children.map(cleanChildren, child => cloneElement(child, childrenProps))}
    </div>
  )
}

Row.propTypes = {
  base: PropTypes.number,
  children: PropTypes.node,
  className: PropTypes.string,
  flush: PropTypes.bool,
  large: PropTypes.number,
  layout: PropTypes.number,
  medium: PropTypes.number,
  reverse: PropTypes.bool,
  small: PropTypes.number,
  verticalSpace: PropTypes.bool,
}

export default Row



// WEBPACK FOOTER //
// ./src/components/Grid/Row/Row.js